// import {
// 	Button,
// 	DatePicker,
// 	Form,
// 	Input,
// 	Modal
// } from "antd";
// import dayjs from "dayjs";
// import { useState } from "react";
// import { useDispatch } from "react-redux";
// import { useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import { loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";
// import { addSalaryHistory } from "../../salaryHistory/salaryHistoryApis";

// const SalaryAddSinglePopup = ({ data, setLoading }) => {
// 	const [isModalOpen, setIsModalOpen] = useState(false);
// 	const [form] = Form.useForm();
// 	const [startDate, setsalaryStartDate] = useState(null);
// 	const [endDate, setsalaryEndDate] = useState(null);
// 	const [loader, setLoader] = useState(false);

// 	const user_id = useParams("id");
// 	const dispatch = useDispatch();

// 	const onFinish = async (values) => {
// 		setLoader(true);
// 		setLoading(true);
// 		const infodata = {
// 			...values,
// 			userId: parseInt(user_id.id),
// 			salary: parseInt(values.salary),
// 			startDate: dayjs(startDate).format("YYYY-MM-DD"),
// 			endDate: dayjs(endDate).format("YYYY-MM-DD"),
// 		};

// 		const resp = await addSalaryHistory(infodata);

// 		if (resp.message === "success") {
// 			setLoader(false);
// 			dispatch(loadSingleStaff(user_id.id));
// 			setIsModalOpen(false);
// 			setLoading(false);
// 			form.resetFields();
// 		} else {
// 			setLoader(false);
// 			setLoading(false);
// 		}
// 	};

// 	const onFinishFailed = (errorInfo) => {
// 		toast.warning("Failed at adding department");
// 		setLoader(false);
// 		setLoading(false);
// 	};
// 	const showModal = () => {
// 		setIsModalOpen(true);
// 	};
// 	const handleOk = () => {
// 		setsalaryStartDate(dayjs());
// 		setsalaryEndDate(dayjs());
// 		setIsModalOpen(false);
// 		setLoader(false);
// 		setLoading(false);
// 		form.resetFields();
// 	};
// 	const handleCancel = () => {
// 		setsalaryStartDate(dayjs());
// 		setsalaryEndDate(dayjs());
// 		setIsModalOpen(false);
// 		setLoader(false);
// 		setLoading(false);
// 		form.resetFields();
// 	};

// 	return (
// 		<>
// 			<div className='text-center'>
// 				<Button type='primary' onClick={showModal}>
// 					Add New Salary
// 				</Button>
// 			</div>
// 			<Modal
// 				title={`Add Salary`}
// 				open={isModalOpen}
// 				onOk={handleOk}
// 				onCancel={handleCancel}>
// 				<Form
// 					form={form}
// 					style={{ marginBottom: "10px" }}
// 					eventKey='department-form'
// 					name='basic'
// 					labelCol={{
// 						span: 6,
// 					}}
// 					wrapperCol={{
// 						span: 16,
// 					}}
// 					onFinish={onFinish}
// 					onFinishFailed={onFinishFailed}
// 					autoComplete='off'>
// 					<div>
// 						<Form.Item
// 							style={{ marginBottom: "10px" }}
// 							label='Salary'
// 							name='salary'>
// 							<Input placeholder='Salary' />
// 						</Form.Item>

// 						<Form.Item
// 							style={{ marginBottom: "10px" }}
// 							label='Start Date'
// 							name='startDate'
// 							valuePropName='startDate'
// 							rules={[
// 								{
// 									required: true,
// 									message: "Please input your start date!",
// 								},
// 							]}>
// 							<DatePicker onChange={(date) => setsalaryStartDate(date)} />
// 						</Form.Item>

// 						<Form.Item
// 							style={{ marginBottom: "10px" }}
// 							label='End Date'
// 							name='endDate'
// 							valuePropName='endDate'>
// 							<DatePicker onChange={(date) => setsalaryEndDate(date)} />
// 						</Form.Item>

// 						<Form.Item
// 							style={{ marginBottom: "10px" }}
// 							label='Comment'
// 							name='salaryComment'>
// 							<Input placeholder='Comment' />
// 						</Form.Item>

// 						<Form.Item
// 							style={{ marginBottom: "20px" }}
// 							wrapperCol={{
// 								offset: 6,
// 								span: 12,
// 							}}>
// 							<Button
// 								onClick={() => setLoader(true)}
// 								type='primary'
// 								size='small'
// 								htmlType='submit'
// 								block
// 								loading={loader}>
// 								Add Now
// 							</Button>
// 						</Form.Item>
// 					</div>
// 				</Form>
// 			</Modal>
// 		</>
// 	);
// };
// export default SalaryAddSinglePopup;


import {
	Button,
	DatePicker,
	Form,
	Input,
	InputNumber,
	message,
	Modal
} from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { addContractDetail, getAllContractDetail } from "../../../redux/rtk/features/contactDetail/contractDetailSlice";
import { getAllContractType } from "../../../redux/rtk/features/masters/contractTypeSlice";
import { loadAllStaff, loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";

const SalaryAddSinglePopup = ({ data, setLoading }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [form] = Form.useForm();
	const [startDate, setsalaryStartDate] = useState(null);
	const [endDate, setsalaryEndDate] = useState(null);
	const [loader, setLoader] = useState(false);

	const dispatch = useDispatch();
	const [calculatedRate, setCalculatedRate] = useState(0);
	const users = useSelector((state) => state.users?.list);
	console.log("users", users);
	
	const contractDetail = useSelector((state) => state.contractDetail?.contractDetail);
	const [calculatedMonthlySalary, setCalculatedMonthlySalary] = useState(0);
	const [calculatedDailyHours, setCalculatedDailyHours] = useState(0);
	const status = true;
	const user_id = useParams("id");
	const handleFormValuesChange = (_, allValues) => {
		const annualSalary = allValues.annualSalary || 0;
		const workingHourPerDay = allValues.workingHourPerDay || 0;

		const monthlySalary = annualSalary / 12;

		const dailyHours = workingHourPerDay * 5;

		const annualWorkingHours = workingHourPerDay * 5 * 52;

		const ratePerHour = annualSalary / annualWorkingHours;

		setCalculatedMonthlySalary(monthlySalary.toFixed(2));
		setCalculatedDailyHours(dailyHours.toFixed(2));
		setCalculatedRate(ratePerHour.toFixed(2));
	};


	useEffect(() => {
		dispatch(getAllContractDetail());
		dispatch(loadAllStaff(status))
		dispatch(getAllContractType());
	}, []);

	const onFinish = async () => {
		try {
			const values = await form.validateFields();
			console.log("values", values);

			const formattedValues = {
				...values,
				userId: parseInt(user_id.id),
				monthlySalary: calculatedMonthlySalary,
				workingHoursPerWeek: calculatedDailyHours,
				workingRatePerHour: calculatedRate,
				startDate: values.startDate ? values.startDate.format('YYYY-MM-DD') : null,  // Only the date
				endDate: values.endDate ? values.endDate.format('YYYY-MM-DD') : null,
			};

			const result = await dispatch(addContractDetail(formattedValues)).unwrap();
			if (result.message === 'success') {
				dispatch(getAllContractDetail());
				dispatch(loadSingleStaff(user_id.id));

			} else {
				message.error('Error adding Contract!');
			}

			form.resetFields();
			// setEditingContractDetail(null);
		} catch (error) {
			console.error('Error:', error);
			message.error('Failed to save contract: ' + error.message);
		}
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at adding department");
		setLoader(false);
		setLoading(false);
	};
	const showModal = () => {
		setIsModalOpen(true);
	};
	const handleOk = () => {
		setsalaryStartDate(dayjs());
		setsalaryEndDate(dayjs());
		setIsModalOpen(false);
		setLoader(false);
		setLoading(false);
		form.resetFields();
	};
	const handleCancel = () => {
		setsalaryStartDate(dayjs());
		setsalaryEndDate(dayjs());
		setIsModalOpen(false);
		setLoader(false);
		setLoading(false);
		form.resetFields();
	};

	return (
		<>
			<div className='text-center'>
				<Button type='primary' onClick={showModal}>
					Add New Salary
				</Button>
			</div>
			<Modal
				title={`Add Salary`}
				open={isModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}>
				<Form
					form={form}
					style={{ marginBottom: "40px" }}
					name="ContractDetail-form"
					labelCol={{ span: 10 }}
					wrapperCol={{ span: 14 }}
					onFinish={onFinish}
					autoComplete="off"
					onValuesChange={handleFormValuesChange}
				>
					{/* <Form.Item
						label="Name"
						name="userId"
						rules={[{ required: true, message: "Please select a user!" }]}
					>
						<Select placeholder="Select User" showSearch allowClear
							filterOption={(input, option) =>
								String(option.children).toLowerCase().includes(input.toLowerCase())
							}
						>
							{users?.map((user) => (
								<Select.Option key={user.id} value={user.id}>
									{`${user.firstName} ${user.lastName}`}
								</Select.Option>
							))}
						</Select>
					</Form.Item> */}

					{/* <Form.Item
                                label="Contract Type"
                                name="contractTypeId"
                                rules={[{ required: true, message: "Please select a contract type!" }]}
                            >
                                <Select placeholder="Select Contract Type" showSearch allowClear
                                    filterOption={(input, option) =>
                                        String(option.children).toLowerCase().includes(input.toLowerCase())
                                    }>
                                    {list?.map((type) => (
                                        <Select.Option key={type.id} value={type.id}>
                                            {type.contractType}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item> */}


					<Form.Item
						style={{ marginBottom: "10px" }}
						label='Start Date'
						name='startDate'
						rules={[
							{
								required: true,
								message: "Please input contact start date!",
							},
						]}
					>
						<DatePicker />
					</Form.Item>

					<Form.Item
						style={{ marginBottom: "20px" }}
						label='End Date'
						name='endDate'
					>
						<DatePicker />
					</Form.Item>

					<Form.Item
						name="annualSalary"
						label="Annual Salary"
						rules={[{ required: true, message: 'Please enter rate per Hour!' }]}
					>
						<InputNumber placeholder="Enter rate per Hour" />
					</Form.Item>

					<Form.Item
						name="workingHourPerDay"
						label="Working Hours Per Day"
						rules={[{ required: true, message: 'Please enter Working Hours Per Day!' }]}
					>
						<InputNumber placeholder="Enter Working Hours Per Day" />
					</Form.Item>
					<Form.Item
							name="comment"
							label="Comment"
						>
							<Input placeholder="Enter comment" />
						</Form.Item>
					<div className="mb-4 p-4 bg-gray-50 rounded-lg">
						<div className="text-lg font-medium">Calculated Values:</div>
						<div className="text-blue-600">
							<p>Monthly Salary: £{calculatedMonthlySalary}</p>
							<p>Working Hours Per Week: {calculatedDailyHours}</p>
							<p>Rate Per Hour: £{calculatedRate}</p>
						</div>
					</div>

					<Button type="primary" block htmlType="submit">
						{/* {editingContractDetails ? 'Update Contract Details' : 'Add Contract Details'} */}
						Add Contract Details
					</Button>
				</Form>
			</Modal>
		</>
	);
};
export default SalaryAddSinglePopup;
